import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Mono } from '../../../../../../generic/ui/Mono'
import IconTextField from '../../../../../../generic/ui/Input/IconTextField'
import KbdChipButton from '../../../../../../generic/ui/KbdChipButton/KbdChipButton'
import GrowerSelector from '../../../../../../generic/ui/Selectors/GrowerSelector'
import BoxesIcon from '../../../../../../generic/icons/IconLib/BoxesIcon'
import PackageBoxIcon from '../../../../../../generic/icons/IconLib/PackageBoxIcon'
import ScaleIcon from '../../../../../../generic/icons/IconLib/ScaleIcon'
import CoinIcon from '../../../../../../generic/icons/IconLib/CoinIcon'
import TypeCalcSelect from '../../../market/Collect/Components/generic/TypeCalcSelect'
import LoadingDotsAnimated from '../../../knisot/Create/Components/LoadingDotsAnimated'
import { IGrowerItem } from '../../../../../../modules/API/Defaults/models/growers'
import LikutEntryHeaderCard from './Components/LikutEntryHeaderCard'
import LikutEntryActionDock from './Components/LikutEntryActionDock'
import useLikutEntry from './services/hooks/useLikutEntry'

interface Props {
    setLikutModalToggle: (flag: boolean) => void;
    goodsCode: string;
    entryInformation: any;
    azmanotListDefault: any[];
    defaultPacks: any;
    setDefaultPacks: (item: any) => void;
    likutInfo: any;
    getToken: string | null;
    updateExistPallets: (palletNum: number) => void;
    getAzmanotDetailes: (orderID: number) => void;
    setInputFocus: () => void;
    defaultPackageList: any[];
    packageType: any;
    checkForSiumLikut: () => void;
    errAlert: (err: any, param?: string) => void;
    orderTitle: any;
    activeResons: boolean;
    user: any;
    persents: number;
    isWeightCalculation: boolean | undefined;
    testForInitialPAcksOfAmount: boolean;
    growersList: IGrowerItem[];
}

export default function LikutEntryModal({
    setLikutModalToggle, goodsCode, entryInformation,
    azmanotListDefault, getToken, setDefaultPacks,
    defaultPacks, likutInfo, updateExistPallets, getAzmanotDetailes,
    setInputFocus, defaultPackageList, packageType, checkForSiumLikut,
    errAlert, orderTitle, activeResons, user, persents,
    testForInitialPAcksOfAmount, isWeightCalculation, growersList
}: Props) {
    const [t] = useTranslation(['likut', 'buttons']);

    const {
        isEditPrice,
        isSelectbleWeight,
        isMandatoryWeight,
        withoutSrika,
        Pack_Type,
        typeCalc,
        growerID,
        setGrowerID,
        packsQnt,
        setPacksQnt,
        weights,
        price,
        currentRestOfgoods,
        disableSaveIfCannotTakeMoreThenRest,
        disableMessage,
        warningMessage,
        handlePrice,
        handleTypeCalc,
        setScaleFunc,
        acceptFunction,
        isScalesAvailable,
        isLoadScales,
        fetchScale,
        TitleText,
        GrowerName,
        bacPic,
    } = useLikutEntry({
        setLikutModalToggle, goodsCode, entryInformation,
        azmanotListDefault, getToken, setDefaultPacks,
        defaultPacks, likutInfo, updateExistPallets, getAzmanotDetailes,
        setInputFocus, defaultPackageList, packageType, checkForSiumLikut,
        errAlert, orderTitle, activeResons, user, persents,
        testForInitialPAcksOfAmount, isWeightCalculation, growersList
    })

    const warningLines = defaultPacks && (defaultPacks?.OrderPacks - defaultPacks?.SupplyQty > currentRestOfgoods)
        ? warningMessage()
        : null;

    const handleClose = () => {
        setLikutModalToggle(false);
        setInputFocus();
    }

    return (
        <Overlay>
            <LikutEntryHeaderCard
                title={TitleText}
                growerName={GrowerName}
                goodsCode={goodsCode}
                packName={entryInformation?.Pack_Name}
                packType={Pack_Type}
                imageBg={bacPic}
            />
            <FormScroll>
                {
                    withoutSrika && (
                        <FieldBlock>
                            <FieldLabel>מגדל</FieldLabel>
                            <GrowerSelector
                                growers={growersList ?? []}
                                value={growersList?.find((g) => g.GrowerID === growerID) ?? null}
                                onSelect={(g) => setGrowerID(g?.GrowerID ?? 0)}
                                allowClear
                            />
                        </FieldBlock>
                    )
                }
                {
                    Pack_Type !== '1' && (
                        <FieldBlock>
                            <FieldLabel>{t('likut_sectionmain_pallet_product_qty')}</FieldLabel>
                            <FieldRow>
                                <FieldSlot>
                                    <IconTextField
                                        type='number'
                                        value={packsQnt}
                                        onChange={(e) => setPacksQnt(e.target.value as any)}
                                        leadingIcon={Pack_Type === '2' ? <BoxesIcon size={16} /> : <PackageBoxIcon size={16} />}
                                        placeholder={t('likut_sectionmain_pallet_product_qty')}
                                    />
                                </FieldSlot>
                                {defaultPacks && !defaultPacks?.isManualEntry ? (
                                    <RestHint>
                                        <Mono>{defaultPacks?.OrderPacks - defaultPacks?.SupplyQty}</Mono>
                                    </RestHint>
                                ) : null}
                                {Pack_Type === '2' && <UnitChip>יח</UnitChip>}
                            </FieldRow>
                        </FieldBlock>
                    )
                }
                {
                    (Pack_Type !== '2' || isMandatoryWeight) && (
                        <FieldBlock>
                            <FieldLabel>{t('likut_sectionmain_pallet_product_weight')}</FieldLabel>
                            <FieldRow>
                                <FieldSlot>
                                    <IconTextField
                                        type='number'
                                        value={weights}
                                        onChange={(e) => setScaleFunc(e.target.value)}
                                        leadingIcon={<ScaleIcon size={16} />}
                                        placeholder={t('likut_sectionmain_pallet_product_weight')}
                                        disabled={!isMandatoryWeight && !isSelectbleWeight}
                                        endAdornment={
                                            <KbdChipButton
                                                onClick={fetchScale}
                                                disabled={!isScalesAvailable}
                                                aria-label='קרא משקל'
                                                title='קרא משקל'
                                            >
                                                {isLoadScales ? <LoadingDotsAnimated /> : <ScaleIcon size={16} color='currentColor' />}
                                            </KbdChipButton>
                                        }
                                    />
                                </FieldSlot>
                                {
                                    defaultPacks && !defaultPacks?.isManualEntry && Pack_Type === '1' ? (
                                        <RestHint>
                                            <Mono>{defaultPacks?.OrderWeight - defaultPacks?.SupplyWeight}</Mono>
                                        </RestHint>
                                    ) : isWeightCalculation && !defaultPacks?.isManualEntry ? (
                                        <RestHint>
                                            <Mono>{Math.round(defaultPacks?.OrderWeight - defaultPacks?.SupplyWeight)}</Mono>
                                        </RestHint>
                                    ) : null
                                }
                                {Pack_Type === '1' && <UnitChip $kg>ק"ג</UnitChip>}
                            </FieldRow>
                        </FieldBlock>
                    )
                }
                {
                    isEditPrice && (
                        <FieldBlock>
                            <FieldLabel>{t('likut_entry_price_label')}</FieldLabel>
                            <FieldRow>
                                <FieldSlot>
                                    <IconTextField
                                        type='number'
                                        value={price}
                                        onChange={(e) => handlePrice(e.target.value)}
                                        leadingIcon={<CoinIcon size={16} />}
                                        placeholder={t('likut_entry_price_label')}
                                    />
                                </FieldSlot>
                                <TypeCalcSlot>
                                    <TypeCalcSelect
                                        handleSelect={handleTypeCalc}
                                        defaultType={typeCalc}
                                    />
                                </TypeCalcSlot>
                            </FieldRow>
                        </FieldBlock>
                    )
                }
                <BalanceNote $warn={entryInformation?.BalanceAmount < 0}>
                    {t('likut_entry_balance_text')}: <Mono>{entryInformation?.BalanceAmount}</Mono>
                </BalanceNote>
                {
                    warningLines && (
                        <ErrorNote>
                            {warningLines.map((line: string, idx: number) => (
                                <span key={idx}>{line}</span>
                            ))}
                        </ErrorNote>
                    )
                }
                {
                    disableSaveIfCannotTakeMoreThenRest && (
                        <ErrorNote>
                            {disableMessage.map((line: string, idx: number) => (
                                <span key={idx}>{line}</span>
                            ))}
                        </ErrorNote>
                    )
                }
            </FormScroll>
            <LikutEntryActionDock
                saveLabel={t('save', { ns: 'buttons' })}
                onSave={acceptFunction}
                showSave={withoutSrika ? !!growerID : true}
                onBack={handleClose}
            />
        </Overlay>
    )
}

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 100;
    background: ${({ theme }) => theme.colors.bgLayout};
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    direction: rtl;
    padding: 0.75rem;
`;

const FormScroll = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    padding-bottom: calc(4.5rem + env(safe-area-inset-bottom, 0px));

    scrollbar-width: none;
    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

const FieldBlock = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
`;

const FieldLabel = styled.span`
    font-size: ${({ theme }) => theme.text.sm};
    color: ${({ theme }) => theme.colors.ink2};
    font-family: ${({ theme }) => theme.fonts.sans};
    padding: 0 0.25rem;
`;

const FieldRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const FieldSlot = styled.div`
    flex: 1;
    min-width: 0;
`;

const RestHint = styled.div`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.875rem;
    height: 2.875rem;
    padding: 0 0.5rem;
    border-radius: 0.875rem;
    border: 1px solid ${({ theme }) => theme.colors.line};
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.ink2};
    font-size: ${({ theme }) => theme.text.md};
`;

const UnitChip = styled.span<{ $kg?: boolean }>`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.875rem;
    height: 2.875rem;
    padding: 0 0.5rem;
    border-radius: 0.875rem;
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.md};
    font-weight: 600;
    color: ${({ theme, $kg }) => ($kg ? theme.colors.success : theme.colors.warning)};
    background: ${({ theme, $kg }) => ($kg ? theme.colors.successSoft : theme.colors.warningSoft)};
`;

const TypeCalcSlot = styled.div`
    flex-shrink: 0;
    width: 11rem;
`;

const BalanceNote = styled.div<{ $warn?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0 0.25rem;
    font-size: ${({ theme }) => theme.text.md};
    font-family: ${({ theme }) => theme.fonts.sans};
    color: ${({ theme, $warn }) => ($warn ? theme.colors.danger : theme.colors.ink3)};
`;

const ErrorNote = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    padding: 0.5rem 0.75rem;
    border: 1px solid ${({ theme }) => theme.colors.danger};
    border-radius: ${({ theme }) => theme.radii.md};
    color: ${({ theme }) => theme.colors.danger};
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.sm};
    font-weight: 600;
`;
